import React from 'react';

const NoLongerAvailableView = () => {
  return (
    <div className="db-modal__content ac-animation--fade-in-from-right">
      <section className="db-section">
        <p className="db-question">Sorry, this car has been reserved.</p>
        <p className="ch-mt--2">
          Unfortunately this car has already been reserved, and we’re unable to
          complete your reservation online.
        </p>
      </section>
    </div>
  );
};

export default NoLongerAvailableView;
